module.exports = __webpack_public_path__ + "img/arrow-right-bold.1f226323.svg";